import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_USER } from './queries';
import { ButtonContainer } from './elements';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewUser = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [createUser] = useMutation(CREATE_USER, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createUser({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      role: 'Lot',
      receivesReleases: false
    }
  });

  const watchReceivesReleases = watch("receivesReleases");

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "Email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Must be a valid email address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
            {...register("firstName", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
            {...register("lastName", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.RolePicker
            label="Role:"
            name="role"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Receives Releases?"
            name="receivesReleases"
            checked={watchReceivesReleases}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewUser;
